module.exports = __webpack_public_path__ + "static/media/Amod-Malviya.8858a826.png";